import {Pipe, PipeTransform} from '@angular/core'
import {nullToUndefined} from '../../core/utils/nullish'

@Pipe({name: 'bgoNullToUndefined', standalone: true})
export class NullToUndefinedPipe<T> implements PipeTransform {
  transform(value: T | null): T | undefined {
    return nullToUndefined(value)
  }
}
